import Password from './index'
export default [
  {
    path: '/change/password',
    name: 'leyousafe-change-password',
    component: Password
  },
]
